import React from 'react';
import PropTypes from 'prop-types';

function WeekNumber({
  date,
  onClickWeekNumber,
  weekNumber
}) {
  const props = {
    className: 'react-calendar__tile',
    style: {
      flexGrow: 1
    }
  };
  const children = React.createElement("span", null, weekNumber);
  return onClickWeekNumber ? React.createElement("button", Object.assign({}, props, {
    onClick: event => onClickWeekNumber(weekNumber, date, event),
    type: "button"
  }), children) : React.createElement("div", Object.assign({}, props), children);
}
WeekNumber.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  onClickWeekNumber: PropTypes.func,
  weekNumber: PropTypes.node.isRequired
};

export { WeekNumber as default };
